window.localStorage.setItem('timestamp', '' + Date.now());

console.log(
    `localStorage: ${new Date(+window.localStorage.getItem('timestamp'))}`
);
